import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_induct_toteService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { tote_lookup_code?: string, warehouseId?: number, container_type_id?: number, transaction_id?: string }): Promise<{ reasons?: string[], toteGroupingId?: number }> 
  {
    let $url = `${environment.backendUrl}api/Totes/functions/induct_tote`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

